/**
 * Reabrir uma solicitação encerrada exige motivo (PM-02): a volta fica na
 * auditoria e na linha do tempo, e a requisição volta a reservar o estoque.
 */
import React, { useState } from "react";

import AsyncButton from "../../../components/AsyncButton";
import SlideOverPanel from "../../../components/SlideOverPanel";
import { SITUACAO_LABELS } from "../../../services/solicitacoes";
import { InlineError, RowEnd, GhostBtn } from "./styles";

const MINIMO = 5;

export default function ReabrirModal({ solicitacao, situacaoAlvo, onConfirmar, onClose }) {
  const [motivo, setMotivo] = useState("");
  const [erro, setErro] = useState("");

  const confirmar = async () => {
    if (motivo.trim().length < MINIMO) {
      setErro(`Explique por que reabrir (mínimo ${MINIMO} caracteres).`);
      throw new Error("motivo curto");
    }
    await onConfirmar(motivo.trim());
  };

  return (
    <SlideOverPanel
      open
      onClose={onClose}
      title={`Reabrir ${solicitacao.numero}`}
      subtitle={`Volta para "${SITUACAO_LABELS[situacaoAlvo] || situacaoAlvo}".`}
      footer={(
        <RowEnd>
          <GhostBtn type="button" onClick={onClose}>Voltar</GhostBtn>
          <AsyncButton variant="primary" silentError successMessage="Solicitação reaberta." onClick={confirmar}>
            Reabrir
          </AsyncButton>
        </RowEnd>
      )}
    >
      <label htmlFor="motivo-reabrir" style={{ fontSize: 13, fontWeight: 600, color: "var(--ink-2)" }}>
        Motivo da reabertura
      </label>
      <textarea
        id="motivo-reabrir"
        autoFocus
        value={motivo}
        onChange={(e) => { setMotivo(e.target.value); setErro(""); }}
        placeholder="Ex.: atendida por engano, peça ainda não saiu"
        style={{
          width: "100%", minHeight: 92, marginTop: 6, padding: "10px 12px", borderRadius: 10,
          border: "1px solid var(--border)", background: "var(--surface)", color: "var(--ink)", fontSize: 14,
        }}
      />
      {erro && <InlineError>{erro}</InlineError>}
    </SlideOverPanel>
  );
}
